import { UseQueryResult } from '@tanstack/react-query';

export const queryToArray = <T>(v: UseQueryResult<T[]>): T[] => v.data ?? [];
